import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '@/lib/api/client';
import type { ApiInvestmentResponse } from './types';

/** Ficha de um investimento (GET /api/investments/{id}). Habilitado só com id. */
export function useInvestment(id: string | null) {
  return useQuery({
    queryKey: ['investment', id],
    queryFn: () => apiFetch<ApiInvestmentResponse>(`/api/investments/${id}`),
    enabled: id != null,
  });
}
